import React from 'react'

import { ChevronIcon, ChevronIconDirection } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ChevronIcon'

import styles from './miniBackNav.module.scss'

const MiniBackNav: React.FC<MiniBackNavProps> = ({ subText, backFunc, ...props }) => {
  return (
    <div className={styles.container} {...props}>
      <button type='button' data-test-id='back' className={styles['back-button']} onClick={backFunc}>
        <ChevronIcon direction={ChevronIconDirection.LEFT} size={20} fillColor={styles.x_light_gray_10} />
        Back
      </button>
      <div className={styles['sub-text']}>{subText}</div>
    </div>
  )
}

type MiniBackNavProps = {
  subText: string
  backFunc: () => void
}

export default MiniBackNav
